const imageHeight = 50;

export default [
  {
    margin: [37, 0, 37, 0],
    columns: [
      {
        width: "auto",
        stack: [
          {
            image: "air",
            width: (imageHeight / 145) * 616,
          },
        ],
      },
      {
        text: null,
        width: 30,
      },
      {
        width: "auto",
        stack: [
          {
            image: "fng",
            width: ((imageHeight + 5) / 166) * 166,
          },
        ],
      },
      {
        text: null,
        width: "*",
      },
      {
        width: "auto",
        stack: [
          {
            image: "first",
            width: ((imageHeight + 10) / 185) * 284,
          },
        ],
      },
    ],
  },
];
